export default __webpack_public_path__ + "static/media/performance.3d119783.png";